import {
  useCallback,
  useLayoutEffect,
  useState,
  type SyntheticEvent,
} from "react";

export type OnIframeDocumentReady = (doc: Document) => void | (() => void);

export function useIframeDocumentReady(
  html: string | null | undefined,
  isLoading: boolean,
  onDocumentReady?: OnIframeDocumentReady,
) {
  const [loaded, setLoaded] = useState<{
    doc: Document;
    html: typeof html;
  } | null>(null);
  useLayoutEffect(() => {
    if (
      !isLoading &&
      loaded &&
      loaded.html === html &&
      loaded.doc.defaultView?.document === loaded.doc
    ) {
      return onDocumentReady?.(loaded.doc);
    }
  }, [loaded, html, isLoading, onDocumentReady]);
  return useCallback(
    (event: SyntheticEvent<HTMLIFrameElement>) => {
      const doc = event.currentTarget.contentDocument;
      if (doc) setLoaded({ doc, html });
    },
    [html],
  );
}
